import React from 'react';
const isBrowser = () => typeof window !== 'undefined';
const userAgent = isBrowser() ? navigator.userAgent : '';
export const UserAgentContext = React.createContext(userAgent);
//# sourceMappingURL=UserAgentContext.js.map
// @zapier/universal-layout@8.11.3 (3d6dc537c)
